import React from 'react';
import { Link } from 'react-router-dom';

import { isHttpLink, isMailLink } from '../../utils/utils';
import { NormalLinkWrapper } from './NormalLinkWrapper';

const styles = {
    root: {
        color: 'inherit',
        textDecoration: 'none',
    },
};

interface ReactRouterLinkWrapperProps {
    to: string;
    children: React.ReactNode;
}

const ReactRouterLinkWrapper: React.FC<ReactRouterLinkWrapperProps> = ({ to, children }) => (
    <Link to={to} style={styles.root}>
        {children}
    </Link>
);

interface LinkWrapperProps {
    to?: string | null;
    translations: Record<string, string>;
    children: React.ReactNode;
}

export const LinkWrapper: React.FC<LinkWrapperProps> = ({ to, translations, children }) => {
    if (!to) {
        return <>{children}</>;
    }

    if (isMailLink(to)) {
        return (
            <a href={to} style={styles.root}>
                {children}
            </a>
        );
    }

    if (isHttpLink(to)) {
        return (
            <NormalLinkWrapper to={to} translations={translations}>
                {children}
            </NormalLinkWrapper>
        );
    }

    return <ReactRouterLinkWrapper to={to}>{children}</ReactRouterLinkWrapper>;
};
